// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1ALcc","col":"styles_col__3Y64r"};